<template>
  <form-wrapper :validator="$v.items">

    <div
      v-for="(item, key) in tables"
      :key="key"
      v-if="key == 1 ? (gotSposob && evidencia) : (gotSposob && percent)">
      <small>
        {{ titles[key].label }}
      </small>
      <hr>

      <div class="row">
        <div class="col-md-6"/>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-6">
              <label style="margin-left: 2em;">{{ $t('message.lblTabZac') }}</label>
            </div>
            <div class="col-md-6">
              <label style="margin-left: 2em;">{{ $t('message.lblTabKonc') }}</label>
            </div>
          </div>
        </div>
      </div>

      <div
        v-for="input in item"
        :key="input.nameP"
        class="row">
        <div class="col-md-9">
          <text-group
            :m="items"
            :name="input.nameP"
            :label="input.label"
            :input-cols="3" />
        </div>
        <div class="col-md-3">
          <text-group
            :m="items"
            :name="input.nameV"
            :input-cols="10"
            label="" />
        </div>
      </div>
    </div>

    <b-button
      class="btn-primary"
      v-if="gotSposob"
      @click="save">
      {{ $t('message.lblSave') }}
    </b-button>

    <p v-if="!gotSposob">
      {{ $t('message.msgTabNoSposob') }}
    </p>
  </form-wrapper>
</template>

<script>
import { minValue, maxValue, decimal } from 'vuelidate/lib/validators';
import restEditor from '@/mixins/restEditor';
import textGroup from '@/components/extractor/moneyTextGroup.vue';

export default {
  components: {
    textGroup,
  },
  mixins: [restEditor],
  data() {
    const id = null;
    const parent = this.$route.params.userId;
    return {
      id,
      parent,
      r18_sposob_uctovania: null,
      r10_sposob_uctovania: null,
      r11_sposob_uctovania: null,
      gotSposob: true,
      sposobs: '',
      items: {
        id: null,
        parent,
        t1a_r1_start: null,
        t1a_r1_end: null,
        t1a_r2_start: null,
        t1a_r2_end: null,
        t1a_r3_start: null,
        t1a_r3_end: null,
        t1a_r4_start: null,
        t1a_r4_end: null,
        t1a_r5_start: null,
        t1a_r5_end: null,
        t1b_r1_start: null,
        t1b_r1_end: null,
        t1b_r2_start: null,
        t1b_r2_end: null,
      },
      titles: {
        1: { label: this.$t('message.lblTab1a'), seeIf: 'gotSposob && evidencia' },
        2: { label: this.$t('message.lblTab1b'), seeIf: 'gotSposob && percent' },
      },
      tables: {
        1: {
          1: { nameP: 't1a_r1_start', nameV: 't1a_r1_end', label: this.$t('message.lblHmotneMajetok') },
          2: { nameP: 't1a_r2_start', nameV: 't1a_r2_end', label: this.$t('message.lblNehmotneMajetok') },
          3: { nameP: 't1a_r3_start', nameV: 't1a_r3_end', label: this.$t('message.lblZasoby') },
          4: { nameP: 't1a_r4_start', nameV: 't1a_r4_end', label: this.$t('message.lblPohladavky') },
          5: { nameP: 't1a_r5_start', nameV: 't1a_r5_end', label: this.$t('message.lblZavazky') },
        },
        2: {
          1: { nameP: 't1b_r1_start', nameV: 't1b_r1_end', label: this.$t('message.lblZasoby') },
          2: { nameP: 't1b_r2_start', nameV: 't1b_r2_end', label: this.$t('message.lblPohladavky') },
        },
      },
      inputsA: {
        1: { nameP: 't1a_r1_start', nameV: 't1a_r1_end', label: this.$t('message.lblHmotneMajetok') },
        2: { nameP: 't1a_r2_start', nameV: 't1a_r2_end', label: this.$t('message.lblNehmotneMajetok') },
        3: { nameP: 't1a_r3_start', nameV: 't1a_r3_end', label: this.$t('message.lblZasoby') },
        4: { nameP: 't1a_r4_start', nameV: 't1a_r4_end', label: this.$t('message.lblPohladavky') },
        5: { nameP: 't1a_r5_start', nameV: 't1a_r5_end', label: this.$t('message.lblZavazky') },
      },
      inputsB: {
        1: { nameP: 't1b_r1_start', nameV: 't1b_r1_end', label: this.$t('message.lblZasoby') },
        2: { nameP: 't1b_r2_start', nameV: 't1b_r2_end', label: this.$t('message.lblPohladavky') },
      },
    };
  },
  validations: {
    items: {
      t1a_r1_start: {
        decimal,
        maxValue: maxValue(9999999.99),
        minValue: minValue(0),
      },
      t1a_r1_end: {
        decimal,
        maxValue: maxValue(9999999.99),
        minValue: minValue(0),
      },
      t1a_r2_start: {
        decimal,
        maxValue: maxValue(9999999.99),
        minValue: minValue(0),
      },
      t1a_r2_end: {
        decimal,
        maxValue: maxValue(9999999.99),
        minValue: minValue(0),
      },
      t1a_r3_start: {
        decimal,
        maxValue: maxValue(9999999.99),
        minValue: minValue(0),
      },
      t1a_r3_end: {
        decimal,
        maxValue: maxValue(9999999.99),
        minValue: minValue(0),
      },
      t1a_r4_start: {
        decimal,
        maxValue: maxValue(9999999.99),
        minValue: minValue(0),
      },
      t1a_r4_end: {
        decimal,
        maxValue: maxValue(9999999.99),
        minValue: minValue(0),
      },
      t1a_r5_start: {
        decimal,
        maxValue: maxValue(9999999.99),
        minValue: minValue(0),
      },
      t1a_r5_end: {
        decimal,
        maxValue: maxValue(9999999.99),
        minValue: minValue(0),
      },
      t1b_r1_start: {
        decimal,
        maxValue: maxValue(9999999.99),
        minValue: minValue(0),
      },
      t1b_r1_end: {
        decimal,
        maxValue: maxValue(9999999.99),
        minValue: minValue(0),
      },
      t1b_r2_start: {
        decimal,
        maxValue: maxValue(9999999.99),
        minValue: minValue(0),
      },
      t1b_r2_end: {
        decimal,
        maxValue: maxValue(9999999.99),
        minValue: minValue(0),
      },
    },
  },

  computed: {
    evidencia() {
      return this.sposobs.includes('ev');
    },

    percent() {
      return this.sposobs.includes('percent');
    },
  },

  methods: {
    async processGet() {
      this.id = await this.restDataSource.getSposobId(this.parent, 6);
      if (this.id !== null) {
        this.r10_sposob_uctovania = (await this.restDataSource.getDataSilent(this.id, 'par6sposob3')).r10_sposob_uctovania;
        this.r11_sposob_uctovania = (await this.restDataSource.getDataSilent(this.id, 'par6sposob4')).r11_sposob_uctovania;
        this.r18_sposob_uctovania = (await this.restDataSource.getDataSilent(this.id, 'par6sposob1')).r18_sposob_uctovania;
        this.sposobs = `${this.r10_sposob_uctovania},${this.r11_sposob_uctovania},${this.r18_sposob_uctovania}`;
        this.items = await this.restDataSource.getData(this.id, 'par6evidencia');
        this.haveSposob();
      } else {
        this.gotSposob = false;
      }
    },

    async processSave() {
      if (this.id === null) {
        this.items.parent = this.parent;
        await this.restDataSource.createData(this.items, 'par6evidencia');
      } else {
        await this.restDataSource.updateData(this.items, 'par6evidencia');
      }
    },
    async haveSposob() {
      const evidencia = await this.sposobs.includes('ev');
      const percent = await this.sposobs.includes('percent');

      if (evidencia || percent) {
        this.gotSposob = true;
      } else {
        this.gotSposob = false;
      }
    },
  },

};
</script>

<style>
.p12 .form-check {
    width: 12%;
}
.item-title {
    margin-top: 3.5%;
    text-align: right;
    font-weight: bold;
}
.pull-right {
    float: right;
}
.add-item {
    float: left;
}
.text-muted {
    color: #777;
}
</style>
